module.exports = __webpack_public_path__ + "img/logo-unsch.505e1666.png";